import { TimerSettings } from '../types';
import firebaseService from '../../../services/FirebaseService';

const DEFAULT_SETTINGS: TimerSettings = {
  workDuration: 25,
  shortBreakDuration: 5,
  longBreakDuration: 15,
  autoStart: false,
  soundEnabled: true
};

class PomodoroSettingsService {
  /**
   * Get pomodoro settings from Firebase
   */
  static async getPomodoroSettings(): Promise<TimerSettings> {
    try {
      return await firebaseService.getPomodoroSettings(DEFAULT_SETTINGS);
    } catch (error) {
      console.error('Failed to load pomodoro settings:', error);
      return DEFAULT_SETTINGS;
    }
  }

  /**
   * Save pomodoro settings to Firebase
   */
  static async setPomodoroSettings(settings: TimerSettings): Promise<TimerSettings> {
    try {
      return await firebaseService.setPomodoroSettings(settings);
    } catch (error) {
      console.error('Failed to save pomodoro settings:', error);
      throw new Error('Failed to save settings');
    }
  }

  /**
   * Update specific pomodoro settings
   */
  static async updatePomodoroSettings(updates: Partial<TimerSettings>): Promise<TimerSettings> {
    const currentSettings = await this.getPomodoroSettings();
    const updatedSettings = { ...currentSettings, ...updates };
    return this.setPomodoroSettings(updatedSettings);
  }

  /**
   * Reset settings to defaults
   */
  static async resetPomodoroSettings(): Promise<TimerSettings> {
    return this.setPomodoroSettings(DEFAULT_SETTINGS);
  }

  /**
   * Get default settings (useful for reset functionality)
   */
  static getDefaultSettings(): TimerSettings {
    return { ...DEFAULT_SETTINGS };
  }
}

export default PomodoroSettingsService; 